<!-- MAP AREA - STARTS -->
<section class="map-area">
    <div class="container-xxl">
        <div class="row" data-aos="fade-up" data-aos-duration="600" data-aos-once="true">
            <div class="col-sm-12">
                <div class="map-heading">
                    <div class="details"> 
                        <h2 class="screen-reader"> {{ 'EnsuringFoodSecurityfortheNation'| translate }}</h2>
                        <p class="screen-reader font-adjust" *ngIf="language=='English'">FCI's foremost priority is to ensure food security for the nation by effectively managing the procurement, storage, and distribution of essential commodities, thereby providing a reliable and sufficient food supply to meet the needs of the population.</p>
                            <p class="screen-reader font-adjust" *ngIf="language=='Hindi'">एफसीआई की सर्वोच्च प्राथमिकता आवश्यक वस्तुओं की खरीद, भंडारण और वितरण का प्रभावी ढंग से प्रबंधन करके राष्ट्र के लिए खाद्य सुरक्षा सुनिश्चित करना है, जिससे जनसंख्या की जरूरतों को पूरा करने के लिए विश्वसनीय और पर्याप्त खाद्य आपूर्ति प्रदान की जा सके।</p>
                    </div>
                </div> 
            </div>
            <div class="col-sm-12">
                <div class="row align-items-center mt-2 mt-lg-2">
                    <div class="col-lg-6 col-xl-6 col-xxl-6 col-md-12">
                        <div class="mapBox screen-reader">
                            <div class="map-legend">
                                <div class="legend-area">
                                    <ol class="">
                                        <li><span class="legend-color-box box-1"></span><span>FCI</span></li>
                                        <li><span class="legend-color-box box-2"></span><span>CWC</span></li>
                                        <li><span class="legend-color-box box-3"></span><span>SWC/State Govt.</span></li>
                                        <li><span class="legend-color-box box-4"></span><span>PWS</span></li>
                                        <li><span class="legend-color-box box-5"></span><span>Silo</span></li>
                                        <li><span class="legend-color-box box-6"></span><span>PEG</span></li>
                                        <li><span class="legend-color-box box-7"></span><span>Others</span></li>
                                    </ol>
                                </div>
                            </div>
                            <div class='map' id='map'>
                                <!-- <button (click)="baseMapVisible()" type="button" data-toggle="tooltip"
                                    data-placement="bottom" title="baseMap" id="baseMap" class="baseMap">
                                    <img src="./assets/images/{{baseMap?'switch_on':'switch_off'}}.png"></button> -->

                            </div>
                    </div>
                    </div>

                    <div class="col-lg-6 col-xl-6 col-xxl-6 col-md-12">
                        <form class="row g-3 mx-0 pb-4-8 custom-2Xborder-bottom"> 
                            <div class="col-md-6 pe-2">
                                <label for="Zone" class="form-label screen-reader">{{'Zone' | translate}}</label>
                                <select class="form-select mapLabelChange screen-reader" aria-label="Default select example" id="zone" #zone (change)="GetRegion(zone.value)">
                                    <option selected value="">-- {{language=='English'? 'All' : 'सभी' }} --</option>
                                    <ng-container *ngFor="let zone of zoneList">
                                    <option  *ngIf="zone.int_Demographic_Id!==32" [value]="zone.int_Demographic_Id" [selected]="CURRENT_ZONE_ID==zone.int_Demographic_Id?true:false">{{language=='English'?zone.vch_Demographic_Name:zone.vch_Demographic_Name_Hindi }}</option>
                                </ng-container>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label for="Region" class="form-label screen-reader">{{'Region' | translate}}</label>
                                <select class="form-select mapLabelChange screen-reader" id="region" aria-label="Default select example" (change)="getAllRegionExtentData($event)">
                                    <option selected value="">-- {{language=='English'? 'All' : 'सभी' }} --</option>
                                        <option *ngFor="let region of regionList" [value]="region.int_Demographic_Id" >{{language=='English'?region.vch_Demographic_Name:region.vch_Demographic_Name_Hindi }}</option>
                                        <!-- [selected]="CURRENT_REGION_ID==region.int_Demographic_Id?true:false" --> 
                                </select>
                            </div>
                        </form>
                        <!-- <hr> -->
                        <h3 class="txtCountry pt-4 screen-reader">{{language=='English'? 'India' : 'भारत' }}</h3>
                        <!-- <div class="as-on-date" *ngIf="asOnDate!=''">As on Date : {{asOnDate}}</div> -->
                        <div class="report-card mt-3">
                            <div class="report-card-sm card-green">
                                <div class="d-flex gap-3 align-items-center">
                                    <div>
                                        <i class="icon-fci-warehouse"></i>
                                    </div>
                                    <div>
                                        <p class="result-no mt-0 mb-1 screen-reader font-adjust">{{INRfromar(totalNoOfDepots)}}</p>
                                        <p class="result-text mb-0 screen-reader font-adjust">{{'TotalNosOfDepots' | translate}}</p>
                                    </div>
                                </div>
                            </div>  
                            <div class="report-card-sm card-yellow">
                                <div class="d-flex gap-3 align-items-center">
                                    <div>
                                        <i class="icon-fci-paddy"></i>
                                    </div>
                                    <div>
                                        <p class="result-no mt-0 mb-1 screen-reader font-adjust">{{INRfromar(totalCapacity)}} <span>{{ 'mapCapacity' | translate }}</span></p>
                                        <p class="result-text mb-0 screen-reader font-adjust">{{'TotalCapacity' | translate}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="report-card-lg card-light-green d-block d-sm-flex justify-content-between">
                                <div class="d-flex d-sm-block mb-3 mb-sm-0">
                                    <div class="mb-2 ms-1 ms-sm-0">
                                        <i class="icon-fci-WheatBag2"></i>
                                    </div>
                                    <div class="ms-4 ms-sm-0">
                                        <p class="result-no mt-0 mb-1 screen-reader font-adjust">{{INRfromar(riceStock)}} <span>{{ 'mapCapacity' | translate }}</span></p>
                                        <p class="result-text mb-0 screen-reader font-adjust">{{'RiceStock' | translate}}</p>
                                    </div>
                                </div>
                                <div class="d-flex d-sm-block mb-3 mb-sm-0">
                                    <div class="mb-2 ms-1 ms-sm-0">
                                        <i class="icon-fci-bag"></i>
                                    </div>
                                    <div class="ms-4 ms-sm-0">
                                        <p class="result-no mt-0 mb-1 screen-reader font-adjust">{{INRfromar(wheatStock)}} <span>{{ 'mapCapacity' | translate }}</span></p>
                                        <p class="result-text mb-0 screen-reader font-adjust">{{'WheatStock' | translate}}</p>
                                    </div>
                                </div>
                                <div class="d-flex d-sm-block">
                                    <div class="mb-2 ms-1 ms-sm-0">
                                        <i class="icon-fci-agronomy"></i>
                                    </div>
                                    <div class="ms-4 ms-sm-0">
                                        <p class="result-no mt-0 mb-1 screen-reader font-adjust">{{INRfromar(totalStock)}} <span>{{ 'mapCapacity' | translate }}</span></p>
                                        <p class="result-text mb-0 screen-reader font-adjust">{{'TotalStock' | translate}}</p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="mt-3 mt-xl-4">
                            <p class="screen-reader font-adjust" *ngIf="language=='English'">The data displayed here is of FCI stocks only. Central pool stocks stored with the state agencies are not reflected in data.</p>
                            <p class="screen-reader font-adjust" *ngIf="language=='Hindi'">यहाँ प्रदर्शित डाटा केवल एफ़सीआई स्टॉक का है । राज्य एजेंसियों के पास भंडारित केंद्रीय पूल का स्टॉक इस डाटा मे सम्मिलित नहीं है ।</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div id="popup" class="ol-popup">
    <a href="#" id="popup-closer" class="ol-popup-closer"></a>
    <div id="popup-content"></div>
</div>
<!-- MAP AREA - ENDS -->
